import React from 'react';
import { useDispatch } from 'react-redux';
import { loadUserFromSpoofing } from 'actions/user';
import queryString from 'query-string';

export const Spoofing = ({ location, history }) => {
    const dispatch = useDispatch();
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        const values = queryString.parse(location.search);
        const spoof = (email, callback, onError) => dispatch(loadUserFromSpoofing(email, callback, onError));

        // replace, so Back doesn't land here and spoof again. A refused spoof leaves the current
        // session as it was, so going back returns to it.
        spoof(values.email, () => history.replace('/'), setError);
    }, []);

    if (error) {
        return (
            <div className="flex flex-center flex-column">
                <h3 role="alert">{error}</h3>
                <button type="button" className="btn btn-primary" onClick={() => history.goBack()}>
                    Go back
                </button>
            </div>
        );
    }

    return (
        <div className="flex flex-center flex-column">
            <h3>Spoofing login into e4enable from Partner Portal...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                Please Wait
            </div>
        </div>
    );
};

export default Spoofing;
